<template>
  <v-app-bar id="core-app-bar" app color="indigo" clipped-right dark>
    <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
      <v-btn dark icon>
        <v-app-bar-nav-icon @click.stop="$store.commit('TOGGLE_CORE_DRAWER')"></v-app-bar-nav-icon>
      </v-btn>
      {{ title }}
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    title: 'Dashboard'
  })
}
</script>

